import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import PrivateRoute from './auth/PrivateRoute';
import LoginForm from './auth/LoginForm';
import AuthorisationPage from './auth/AuthrisationPage';
import ImmobilisationsPage from './interfaces/ImmobilierPage';
import ChefchantierDashboard from './interfaces/ChefChantierDashboard';
import ResponsabletechniqueDashboard from './interfaces/ResponsableTechniqueDashboard';
import ComptableDashboard from './interfaces/ComptableDashboard';
import DgDashboard from './interfaces/DgDashboard';
import ChargeStructurePage from './interfaces/ChargeStructurePage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Route publique - Page de connexion */}
            <Route path="/login" element={<LoginForm />} />
            
            {/* Route par défaut - redirection vers login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            {/* Page d'autorisation non autorisée */}
            <Route path="/unauthorized" element={<AuthorisationPage />} />
            
            {/* Routes protégées existantes */}
            <Route 
              path="/ChefchantierDashboard" 
              element={
                <PrivateRoute allowedRoles={['chefchantier']}>
                  <ChefchantierDashboard />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/ResponsabletechniqueDashboard" 
              element={
                <PrivateRoute allowedRoles={['responsabletechnique']}>
                  <ResponsabletechniqueDashboard />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/ComptableDashboard" 
              element={
                <PrivateRoute allowedRoles={['controleur']}>
                  <ComptableDashboard />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/DgDashboard" 
              element={
                <PrivateRoute allowedRoles={['directeur']}>
                  <DgDashboard />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/ChargeStructurePage" 
              element={
                <PrivateRoute allowedRoles={['chargestructure']}>
                  <ChargeStructurePage />
                </PrivateRoute>
              } 
            />
            
            {/* NOUVELLE ROUTE AJOUTÉE - Gestion des Immobilisations */}
            <Route 
              path="/ImmobilierPage" 
              element={
                <PrivateRoute allowedRoles={['immobilisations']}>
                  <ImmobilisationsPage />
                </PrivateRoute>
              } 
            />
            
            {/* Route catch-all pour les pages non trouvées */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
